import React from 'react'
import { connect } from 'react-redux'
import CouponActions from '../../Redux/CouponRedux'
import moment from 'moment'
// import Modal from 'react-responsive-modal'

class ViewBusinessCoupon extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: []
    }
  }

  render () {
    return (
      <section className='section' style={{width: '80vw'}}>
        <div className='title-block'>
          <h3 className='title'>View Business Tags</h3>
        </div>
        <div className='row'>
          <div className='col-6'>
            <div className='section'>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Title</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.title || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Tag</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.tag || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Type</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.type || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Status</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.status || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Platform</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.platform || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Product Type</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.product_type || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Max Usage</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.max_usage || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Max Usage Per user</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.max_usage_per_user || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Discount Type</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.discount_type || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Discount Amount</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.discount_amount || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Min Amount</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.min_amount || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label>Max Amount</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.max_amount || '-' }
                </div>
              </div>
            </div>
          </div>
          <div className='col-6'>
            <div className='section'>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>First Order Only</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.first_order_only || 'No first order limitation' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>First User Only</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.first_user_only || 'No first user limitation' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Start At</label>
                </div>
                <div className='col-8'>
                  { moment(this.props.detail.start_at).format('DD/MM/Y hh:mm A') || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>End At</label>
                </div>
                <div className='col-8'>
                  { moment(this.props.detail.end_at).format('DD/MM/Y hh:mm A') || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Description</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.description || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Updated at</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.updated_at || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Count</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.stats.count || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Order Count</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.stats.order_count || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Claimer Count</label>
                </div>
                <div className='col-8'>
                  { this.props.detail.stats.claimer_count || '-' }
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-4'>
                  <label className='control-label'>Image</label>
                </div>
                <div className='col-8'>
                  {this.props.detail.image_url
                    ? <img
                      alt={this.props.detail.image_file}
                      title={this.props.detail.image_file}
                      className='img-responsive'
                      src={this.props.detail.image_url}
                      style={{ maxWidth: '100%' }}
                      />
                    : 'No Image'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  getAllCouponTag: (data) => dispatch(CouponActions.couponTagRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ViewBusinessCoupon)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/ViewBusinessCoupon.js